<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link> >
      <router-link :to="'/persona_vacunapers/' + p_idAtencion + '/' + p_numero + '/' + p_idPersona + '/' + p_edad">Vacunas</router-link>
      > Plan de Vacunación
    </div>
    <hr>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="filtroVacuna" class="form-label">Filtrar por Vacuna:</label>
        <select id="filtroVacuna" v-model="filtroVacuna" class="form-control">
          <option value="">Todas las Vacunas</option>
          <option v-for="vacuna in vacunas" :key="vacuna" :value="vacuna">{{ vacuna }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <button @click="imprimir" class="btn btn-secondary mt-4">Imprimir</button>
      </div>
    </div>
    <div v-if="datosCargados">
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>Vacuna</th>
              <th v-for="anio in rangoAnios" :key="anio">{{ anio }} años</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacuna in vacunasFiltradas" :key="vacuna">
              <td>{{ vacuna }}</td>
              <td v-for="anio in rangoAnios" :key="anio">
                <span v-if="isVacunaAplicada(vacuna, anio)" :title="getDescripcion(vacuna, anio)">✔️</span>
                <span v-else-if="isVacunaPlanificada(vacuna, anio)" :title="getDescripcion(vacuna, anio)">❌</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      p_idPersona: 0,
      p_idAtencion: 0,
      p_numero: '',
      p_edad: 0,
      datosCargados: false,
      vacunas: [],
      vacunacionData: [],
      planVacunacionData: [],
      filtroVacuna: '',
    };
  },
  computed: {
    rangoAnios() {
      // Genera un rango de 5 a 18 años
      let anios = [];
      for (let i = 5; i <= 18; i++) {
        anios.push(i);
      }
      return anios;
    },
    vacunasFiltradas() {
      if (this.filtroVacuna) {
        return this.vacunas.filter(vacuna => vacuna === this.filtroVacuna);
      }
      return this.vacunas;
    },
  },
  methods: {
    async cargarDatos() {
      try {
        const [responsePersona, responsePlan] = await Promise.all([
          api.get(`/vwvacunaperss/idpersona/${this.p_idPersona}`),
          api.get('/vwvacunaplans'),
        ]);
        this.vacunacionData = responsePersona.data;
        this.planVacunacionData = responsePlan.data;
        this.vacunas = [...new Set(this.planVacunacionData.map(item => item.vacunaNombre))];
        this.datosCargados = true;
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    },
    calcularEdadEnAnios(fechaApli, fechaNac) {
      const fechaAplicacion = new Date(fechaApli);
      const fechaNacimiento = new Date(fechaNac);
      const diferenciaAnios = fechaAplicacion.getFullYear() - fechaNacimiento.getFullYear();
      return diferenciaAnios;
    },
    isVacunaAplicada(vacuna, anio) {
      return this.vacunacionData.some(item => item.vacunaNombre === vacuna && this.calcularEdadEnAnios(item.fechaApli, item.personaFechaNac) === anio);
    },
    isVacunaPlanificada(vacuna, anio) {
      return this.planVacunacionData.some(item => item.vacunaNombre === vacuna && item.edadMeses === anio * 12);
    },
    getDescripcion(vacuna, anio) {
      const vacunaItem = this.vacunacionData.find(item => 
        item.vacunaNombre === vacuna && 
        this.calcularEdadEnAnios(item.fechaApli, item.personaFechaNac) === anio
      );

      if (!vacunaItem) return ''; // Si no se encuentra el item, retorna cadena vacía.

      // Función para formatear la fecha en DD-MM-YYYY
      const formatDate = (date) => {
        if (!date) return ''; // Si la fecha es nula o indefinida, no hacer nada.
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      // Construimos la descripción condicionalmente
      let descripcion = vacunaItem.observacion;

      // Agregar vacunaProdNombre si no es nulo o indefinido
      if (vacunaItem.vacunaProdNombre) {
        descripcion += "; " + vacunaItem.vacunaProdNombre;
      }

      // Agregar lote si no es nulo o indefinido
      if (vacunaItem.lote) {
        descripcion += "; " + vacunaItem.lote;
      }

      // Agregar la fecha formateada si existe fechaApli
      if (vacunaItem.fechaApli) {
        descripcion += "; " + formatDate(vacunaItem.fechaApli);
      }

      return descripcion;
    },
    imprimir() {
      window.print();
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.p_idPersona = this.$route.params.p_idpersona;
    this.p_idAtencion = this.$route.params.p_idatencion;
    this.p_numero = this.$route.params.p_numero;
    this.p_edad = this.$route.params.p_edad;
    this.cargarDatos();
  },
};
</script>

<style scoped>
.breadcrumb-container {
  margin-bottom: 15px;
}

.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

th, td {
  padding: 10px;
}

.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}
</style>